import { contactData } from '@/mocks/homeData';

export default function ContactSection() {
  return (
    <section id="contact" className="py-16 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[800px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            联系我们
          </h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base max-w-[500px] mx-auto">
            片源需求、问题反馈或合作意向，我们随时倾听
          </p>
        </div>

        <div className="bg-background-50 rounded-lg border border-background-200/60 p-8 md:p-10">
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed text-center max-w-[600px] mx-auto">
            {contactData.description}
          </p>

          <div className="mt-8 grid grid-cols-1 sm:grid-cols-3 gap-5">
            <div className="text-center p-5 rounded-lg bg-background-100 border border-background-200/50">
              <div className="w-10 h-10 mx-auto flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
                <i className="ri-mail-line text-lg"></i>
              </div>
              <h3 className="mt-3 text-sm font-semibold text-foreground-900">电子邮箱</h3>
              <p className="mt-1 text-xs text-foreground-500 break-all">{contactData.email}</p>
            </div>

            <div className="text-center p-5 rounded-lg bg-background-100 border border-background-200/50">
              <div className="w-10 h-10 mx-auto flex items-center justify-center rounded-full bg-accent-100 text-accent-600">
                <i className="ri-wechat-line text-lg"></i>
              </div>
              <h3 className="mt-3 text-sm font-semibold text-foreground-900">微信公众号</h3>
              <p className="mt-1 text-xs text-foreground-500">{contactData.wechat}</p>
            </div>

            <div className="text-center p-5 rounded-lg bg-background-100 border border-background-200/50">
              <div className="w-10 h-10 mx-auto flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600">
                <i className="ri-qq-line text-lg"></i>
              </div>
              <h3 className="mt-3 text-sm font-semibold text-foreground-900">QQ客服</h3>
              <p className="mt-1 text-xs text-foreground-500">{contactData.qq}</p>
            </div>
          </div>

          <p className="mt-8 text-center text-xs text-foreground-500">
            <i className="ri-time-line mr-1"></i>
            {contactData.tips}
          </p>
        </div>
      </div>
    </section>
  );
}